var _excluded = ["onSelectionChange", "initialSelectedItem"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteType from '../utils/autocomplete-types';
import * as autocompletePropTypes from '../utils/prop-types';
import AllhomesAutocomplete from '../allhomes-autocomplete';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ADDRESS = AutocompleteType.ADDRESS;
var AddressSelectAutocomplete = _ref => {
  var onSelectionChange = _ref.onSelectionChange,
    initialSelectedItem = _ref.initialSelectedItem,
    props = _objectWithoutProperties(_ref, _excluded);
  var typeProps = {
    types: [ADDRESS.name],
    placeholder: 'Type your address'
  };
  var handleSelectionChange = function handleSelectionChange() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return onSelectionChange(items[0]);
  };
  return ___EmotionJSX(AllhomesAutocomplete, _extends({}, typeProps, {
    onSelectionChange: handleSelectionChange,
    initialSelectedItems: initialSelectedItem ? [initialSelectedItem] : [],
    singleSelect: true
  }, props));
};
AddressSelectAutocomplete.propTypes = {
  initialSelectedItem: autocompletePropTypes.value,
  onSelectionChange: PropTypes.func
};
AddressSelectAutocomplete.defaultProps = {
  initialSelectedItem: null,
  onSelectionChange: () => {}
};
export default AddressSelectAutocomplete;